/* eslint-disable no-unused-vars */
import { useState } from 'react';
import toast from 'react-hot-toast';

const toBase64 = (file) => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = () => resolve(reader.result);
  reader.onerror = (error) => reject(error);
});

const useFileDropZone = (size, maxFilesCount = 3, files = []) => {
  const [cover, setCover] = useState(files);
  const [base64Files, setBase64Files] = useState([]);

  const handleDropCover = async ([file], obj) => {
    if (!file) {
      if (obj && obj[0] && obj[0].errors && obj[0].errors[0].code === 'file-too-large') {
        toast.error(`Dosya boyutu ${size} KB'dan küçük olmalı`);
      } else if (obj && obj[0] && obj[0].errors && obj[0].errors[0].code === 'too-many-files') {
        toast.error(`En fazla ${maxFilesCount} dosya yükleyebilirsiniz.`);
      } else {
        toast.error('Dosya tipi desteklenmiyor.');
      }
      return;
    }
    const covers = [...cover];
    if (maxFilesCount && (covers.length + 1) > maxFilesCount) {
      toast.error(`En fazla ${maxFilesCount} dosya yükleyebilirsiniz.`);
      return;
    }

    covers.push(file);
    setCover(covers);

    const newBase64File = await toBase64(file);
    const oldBase64Files = [...base64Files];
    oldBase64Files.push(newBase64File);
    setBase64Files(oldBase64Files);
  };

  const handleRemoveCover = () => {
    setCover([]);
    setBase64Files([]);
  };

  const removeFile = (file) => {
    const covers = [...cover];
    const oldBase64Files = [...base64Files];
    const index = covers.findIndex((f) => f.name === file.name);
    covers.splice(index, 1);
    oldBase64Files.splice(index, 1);
    setCover(covers);
    setBase64Files(oldBase64Files);
  };

  return { cover, handleDropCover, handleRemoveCover, removeFile, base64Files, setCover };
};

export default useFileDropZone;
